import axios from "axios";

export async function loadUserInfo(
  accessToken: string,
  loginUrl: string,
  realm: string
): Promise<Record<string, any>> {
  const baseUrl = loginUrl.replace(/\/$/, "");
  const response = await axios.get<Record<string, any>>(
    `${baseUrl}/realms/${realm}/protocol/openid-connect/userinfo`,
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );

  return response.data;
}
